import { render, staticRenderFns } from "./userdropdown.vue?vue&type=template&id=56e0d83c&scoped=true"
import script from "./userdropdown.vue?vue&type=script&lang=js"
export * from "./userdropdown.vue?vue&type=script&lang=js"
import style0 from "./userdropdown.vue?vue&type=style&index=0&id=56e0d83c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0d83c",
  null
  
)

export default component.exports